import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useDebounceForInput } from 'utils';
import { OutlinedInput, InputAdornment } from '@material-ui/core';
import { ClearIcon, SearchIcon } from '../Icons';

const Search = React.forwardRef(
  ({ search, applySearch, classes, withDebounce, autoFocus, isHeaderWithin, hasClear, onClear, ...props }, ref) => {
    const [value, setValue] = withDebounce ? useDebounceForInput(applySearch, 450, search) : [search, applySearch];

    const handleClear = () => {
      applySearch('');
      setValue('');
      return onClear && onClear();
    };

    const rootClassName = cx(isHeaderWithin ? classes.headerSearch : classes.root, props.customRootStyle);
    return (
      <OutlinedInput
        ref={ref}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        fullWidth
        classes={{ root: rootClassName, input: classes.input }}
        autoFocus={autoFocus}
        startAdornment={
          !isHeaderWithin && (
            <InputAdornment position="start">
              <SearchIcon className={classes.searchIcon} />
            </InputAdornment>
          )
        }
        endAdornment={
          hasClear && value.length > 1 ? (
            <InputAdornment position="end" classes={{ root: classes.adornedEnd }}>
              <ClearIcon onClick={handleClear} data-testid="btn-clear" aria-label="btn-clear" />
            </InputAdornment>
          ) : null
        }
        {...props}
      />
    );
  },
);

Search.propTypes = {
  search: PropTypes.string,
  applySearch: PropTypes.func.isRequired,
  classes: PropTypes.objectOf(PropTypes.string),
  customRootStyle: PropTypes.objectOf(PropTypes.string),
  withDebounce: PropTypes.bool,
  autoFocus: PropTypes.bool,
  isHeaderWithin: PropTypes.bool,
  hasClear: PropTypes.bool,
};

Search.defaultProps = {
  classes: {},
  withDebounce: false,
  isHeaderWithin: false,
  hasClear: false,
};

export default Search;
